// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

import { Theme } from '@mui/material';

export default function InputLabel<T extends Theme>(theme: T) {
    return {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.grey[600],
                },
                outlined: {
                    top: -4,
                    lineHeight: '1em',
                    '&.MuiInputLabel-sizeSmall': {
                        lineHeight: '1em',
                    },
                    '&.MuiInputLabel-shrink': {
                        background: theme.palette.background.paper,
                        padding: '0 8px',
                        marginLeft: -6,
                        lineHeight: '1.4375em',
                    },
                },
            },
        },
    };
}
